import { lazy } from 'react'

export const SettingsRoutes = [
  {
    path: '/settings/organization',
    component: lazy(() => import('../views/organization-settings')),
    meta: {
      action: 'call',
      resource: "APP_VIEW_SETTINGS"
    }
  },
  {
    path: '/settings/office',
    component: lazy(() => import('../views/office-settings')),
    meta: {
      action: 'call',
      resource: 'OFC_VIEW_SETTINGS|APP_VIEW_SETTINGS'
    }
  },
  {
    path: '/settings/request',
    component: lazy(() => import('../views/request-settings')),
    meta: {
      action: 'call',
      resource: 'OFC_VIEW_SETTINGS|APP_VIEW_SETTINGS'
    }
  },
  {
    path: '/settings/meeting',
    component: lazy(() => import('../views/meeting-settings')),
    meta: {
      action: 'call',
      resource: 'APP_VIEW_SETTINGS'
    }
  },
  {
    path: '/settings/security',
    component: lazy(() => import('../views/security-settings')),
    meta: {
      action: 'call',
      resource: "APP_VIEW_SETTINGS"
    }
  }
]

